{
  "iconStyle": {
    "alignment": "Alineación",
    "screen": "Pantalla alineada",
    "north": "Alineado al norte"
  },
  "mapObjectSelectionHelpers": {
    "layerNotVisible": {
      "message": "El objeto de mapa seleccionado se encuentra en una capa visualmente oculta",
      "cta": "Alternar la visibilidad"
    },
    "objectOnDifferentLevel": {
      "message": "El objeto de mapa seleccionado está en un nivel diferente",
      "cta": "Cambiar nivel"
    },
    "layerNotVisibleAndObjectOnDifferentLevel": {
      "message": "El objeto de mapa seleccionado se encuentra en una capa visualmente oculta y en un nivel diferente",
      "cta": "Alterna la visibilidad y cambia de nivel"
    }
  },
  "dates": {
    "objectDetails": {
      "noRangesAvailable": "Sin rangos",
      "rangeAvailable": "1 rango",
      "rangesAvailable": "{{ rangesAmount }} rangos",
      "add": "Añade intervalos de fecha y hora",
      "noDataAvailable": "No hay datos disponibles"
    },
    "dateRangeAttribute": {
      "name": "Nombre",
      "dates": "Fechas",
      "time": "Hora"
    },
    "startDate": "Fecha de inicio",
    "attributeName": "Intervalo de fecha y hora (p. ej., turnos)",
    "attributeInfoBox": {
      "title": "Ejemplos de valores de datos",
      "infoBlurb": "Utilice este atributo para definir el rango de fechas y horas en las que desea que esté visible el objeto de mapa. Por ejemplo, el «<strong>turno matutino de John» aparecerá</strong> entre <strong>las 9:45 a. m. y las 17:45</strong> <strong>p.</strong> m. Esta visibilidad también se puede determinar seleccionando el intervalo de fecha y hora del mapa en la parte inferior derecha del mapa.",
      "johnsMorningShift": "El turno matutino de John"
    },
    "attributeSettings": "Configuración de atributos",
    "addRange": "Agregar rango",
    "mapObjectDateFiltered": "El objeto de mapa seleccionado se filtra por la fecha seleccionada",
    "mapObjectDateFilteredCta": "Eliminar el filtro de fecha",
    "tooltip": {
      "title": "Intervalo de fechas y horas recurrentes",
      "blurb": "Usa esta función para establecer intervalos de repetición para un evento específico con respecto a las fechas que ocurren regularmente. Por ejemplo, turnos de empleados"
    },
    "calendarTooltip": "Filtro de mapa de fecha y hora"
  },
  "ranges": "rangos",
  "digitalTwin": {
    "loading": {
      "header": "Construyendo tu gemelo digital",
      "message": "Esto puede tardar unos instantes"
    },
    "restarting": {
      "header": "¡Uy!",
      "message": "Lo siento, algo salió mal. Vamos a hacer que te vuelvas a conectar al gemelo digital..."
    }
  },
  "styles": {
    "arrows": {
      "sameAsLine": "Igual que la línea",
      "custom": "Personalizado"
    },
    "customImage": "Imagen personalizada",
    "customColour": "Color personalizado",
    "selectImage": "Selecciona una imagen personalizada",
    "customImagePerModel": "Solo puedes subir 1 imagen por modelo. Puedes reemplazar tu selección a continuación.",
    "customImageAspectRatio": "Esta imagen no tiene la relación de aspecto especificada de {{ aspectRatio }} Puede aparecer estirada o aplastada."
  },
  "moveLayer": {
    "front": "Traiga al frente",
    "back": "Enviar a la parte posterior"
  },
  "controls": {
    "user_location": "Ubicación del usuario"
  },
  "deleteAttributePrompt": {
    "title": "¿Está seguro de que desea eliminar este atributo?",
    "message": "Esto eliminará los datos de los atributos de todos los objetos de esta capa de forma permanente. Esta acción no es reversible."
  },
  "fileUpload": {
    "image_comment": "Sube la imagen para comentar",
    "invalid": "El archivo que has subido no es válido. Sube un archivo .png, .jpg o .jpeg válido"
  },
  "comments": {
    "edit": "Editar comentario",
    "delete": "Eliminar comentario",
    "image": "Agregar imagen",
    "replaceImage": "Reemplazar imagen"
  },
  "upload_asset": {
    "icon": "icono",
    "model": "modelo 3D",
    "upload_model": "Cargue un modelo 3D",
    "update_model": "Actualice el modelo 3D",
    "upload_icon": "Sube un icono",
    "update_icon": "Editar icono",
    "name": "Nombre de {{ assetType }}",
    "categories": "Categorías",
    "search_for_categories": "Búsqueda de categorías",
    "select_asset": "Selecciona {{ assetType }}",
    "select_file": "Selecciona un archivo",
    "file_end": "El archivo debe terminar en",
    "or": "o",
    "not_support_custom_image": "El modelo que has subido no admite imágenes personalizadas. Para ver cómo habilitarlo, consulta el artículo ",
    "select_thumbnail": "Miniatura",
    "something_went_wrong": "Algo salió mal",
    "image_size": "Tamaño de la imagen",
    "image_style": "Estilo de imagen",
    "image_file": "Archivo de imagen",
    "enable_colour_customisation": "Habilite la personalización del color"
  },
  "permissionTooltip": "No tienes permiso para ",
  "createLayerOptions": "Crear opciones de capa",
  "cancelDrawing": "Cancelar el dibujo",
  "deleteObject": "Eliminar objeto",
  "importNoWebSocketsToast": "Las capas han terminado de importarse o copiarse; actualízalas para ver las capas",
  "refresh": "Actualiza"
}